module.exports = __webpack_public_path__ + "static/media/07_approximated_point.7fb2d8fe.png";